import Decimal from 'decimal.js';

export class Monetary {
    private _calculate = (price: number, taxes: Array<any>, quantity: number) => {
        return new Decimal(price) // Price to Decimal.
            .toDecimalPlaces(2) // Roundeing Decimal
            .times(quantity) // Times the quantity.
            .plus(this.vat ? this._reduce(taxes, quantity) : 0) // Adding VAT times the quantity 
            .toDecimalPlaces(2) // Roundeing Decimal
            .toNumber(); // Returning the number.
    }

    private _round = (value: number) => {
        return new Decimal(value)
            .toDecimalPlaces(2)
            .toNumber();
    }

    private _reduce = (array: Array<any>, times: number = 1) => array.map(item => new Decimal(item.amount).toDecimalPlaces(2).times(times)) // The item amount to Decimal and rounding it.
        .reduce((sum, val) => sum.plus(val), new Decimal(0)) // Sums up the amounts.
        .toDecimalPlaces(2) // Rounding total.
        .toNumber(); // Returning the number.

    private _getPriceFor = (price: any, quantity: number) => price.campaignPrice
        ? this._calculate(price.campaignPrice, price.campaignTaxes, quantity) // I campaign price exists.
        : this._calculate(price.salesPrice, price.salesTaxes, quantity)

    private _getDiscountPriceFor = (price: any, quantity: number) => price.discountPrice
        ? this._calculate(price.discountPrice, price.discountTaxes, quantity)
        : 0;

    public $i18n: any;
    public country: string;
    public currency: string;
    public vat: boolean;

    constructor($i18n: any, { country, currency, vat }: { country: string, currency: string; vat: boolean; }) {
        this.country = country;
        this.currency = currency;
        this.vat = vat;
        this.$i18n = $i18n;
    }

    update({ country, currency, vat }: { country: string, currency: string; vat: boolean; }) {
        this.country = country;
        this.currency = currency;
        this.vat = vat;
    }

    round = (value: number) => this._round(value);

    calculate = (net: number, tax: number) => new Decimal(net)
        .plus(this.vat ? new Decimal(tax).toDecimalPlaces(2) : 0)
        .toDecimalPlaces(2)
        .toNumber();

    display = (value: Number, currency?: String) =>
        `${this.$i18n.n(value, 'currency', this.$i18n.locale, {
            currency: currency ?? this.currency
        }).replace(currency ?? this.currency, '').trim()} ${currency ?? this.currency}`;

    displayCalculate = (net: Number, taxes: Number, currency?: String) => this.display(this.calculate(net, taxes), currency);

    getProductPrice = (product: any) => this._getPriceFor(product.prices[this.country]
        .filter((price: any) => price.currency === this.currency)
        .find(() => true), product.quantity ?? 1);

    getProductDiscount = (product: any) => this._getDiscountPriceFor(product.prices[this.country]
        .filter((price: any) => price.currency === this.currency)
        .find(() => true), 1);

    getProductPreviousPrice = (product: any) => Object.keys(product.previousPrices30Days).length !== 0 && product.previousPrices30Days.constructor === Object
        ? this._getPriceFor(product.previousPrices30Days[this.country]
            .filter((price: any) => price.currency === this.currency)
            .find(() => true), product.quantity)
        : null;
}